import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import cn from 'classnames';
import get from 'lodash/get';

class TableDisplay extends Component {
  static propTypes = {
    tracking: PropTypes.object
  }
  render() {
    const { tracking } = this.props;
    const { order } = tracking;

    const orderDate = moment(order.createdAt).tz('America/Chicago').format('llll');
    const delTime = (tracking.delivery) ? moment(tracking.delivery.timestamp).tz('America/Chicago').format('llll') : null;
    const puTime = (tracking.pickup) ? moment(tracking.pickup.timestamp).tz('America/Chicago').format('llll') : null;

    const classNames = cn({ col: true, s12: true, m4: tracking.delivery, m6: !tracking.delivery });

    return (
      <div className="row">
        <div className={classNames}>
          <div className="row">
            <div className="col s12">
              <strong>From</strong>
              <div>{get(order, 'from.name')}</div>
              <div>{get(order,'from.address.address')}</div>
            </div>
          </div>
          <div className="row">
            <div className="col s12">
              <strong>To</strong>
              <div>{get(order,'to.name')}</div>
              <div>{get(order,'to.address.address')}</div>
            </div>
          </div>
          <div className="row">
            <div className="col s12">
              <strong>Reference</strong>
              <div>{get(order,'reference')}</div>
            </div>
          </div>
        </div>
        <div className={classNames}>
          <div className="row">
            <div className="col s12">
              <strong>Order Date</strong>
              <div>{orderDate}</div>
            </div>
          </div>
          <div className="row">
            <div className="col s12">
              <strong>Class</strong>
              <div>{tracking.code || 'pending'}</div>
            </div>
          </div>
          <div className="row">
            <div className="col s12">
              <strong>Service Level</strong>
              <div>{get(order,'serviceLevel.name')}</div>
            </div>
          </div>
          <div className="row">
            <div className="col s12">
              <strong>Piece</strong>
              <div>{`${tracking.piece} of ${tracking.pieces}`}</div>
            </div>
          </div>
          {puTime &&
          <div className="row">
            <div className="col s12">
              <strong>Picked Up</strong>
              <div>{puTime}</div>
            </div>
          </div>
          }
        </div>
        {tracking.delivery &&
        <div className={classNames}>
          <div className="row">
            <div className="col s12">
              <strong>Delivered</strong>
              <div>{delTime} to <strong><em>{tracking.delivery.receiver}</em></strong></div>
              <div><img src={tracking.delivery.signature} style={{ transform: 'rotate(90deg)', width: '50%' }} alt="" /></div>
            </div>
          </div>
        </div>
        }
      </div>
    )
  }
}

export default TableDisplay;


// WEBPACK FOOTER //
// ./src/components/Orders/TableDisplay.js